export const fbConfig = {
  apiKey: 'AIzaSyBXKY-_HUR0ul13oSam3qaqIcHhwIFi8XY',
  authDomain: 'data-interview-questions.firebaseapp.com',
  databaseURL: 'https://data-interview-questions.firebaseio.com',
  projectId: 'data-interview-questions',
  storageBucket: 'data-interview-questions.appspot.com',
  messagingSenderId: '254719278838',
  appId: '1:254719278838:web:c1cd098b4ad65857d2f6d7',
  measurementId: 'G-3SC5T24L09',
};

export const fbEmail = 'zihenglin.gta@gmail.com';
export const fbPassword = 'P/[SJ&"*96ktFQ';
